import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncMoreMenu = Load(() => import(/* webpackChunkName: "more-menu" */'./containers/MoreMenu'));
const AsyncHomePage = Load(() => import(/* webpackChunkName: "homepage" */'./HomePage'), {}, true);
const AsyncHomeScreen = Load(() => import(/* webpackChunkName: "homescreen" */'./HomeScreen'), {}, true);

const HomescreenRoutes = [
  (
    <NavigationableLayout
      key="more"
      path={`${basePath}/more`}
      hideFooter
      component={AsyncMoreMenu}
      showBottomNavigation
      noNavbar
    />
  ),
  (
    <NavigationableLayout
      exact
      key="homepage"
      path={basePath}
      component={isCordova() ? AsyncHomeScreen : AsyncHomePage}
      showSearchInNavbar={isCordova()}
      showBottomNavigation
      transparentNavbar
      hideFooter
    />
  ),
];

export default HomescreenRoutes;
